export const stringToSlug = (str) => str.toLowerCase().replace(/[\W_]+/g, '-');